"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _default = {
  PropTypes: {
    images: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      alt: _propTypes.string,
      caption: _propTypes.string,
      category: (0, _propTypes.shape)({
        id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
        name: _propTypes.string
      }),
      links: _propTypes.object
    })).isRequired,
    hotelDetail: (0, _propTypes.shape)({
      name: _propTypes.string,
      address: (0, _propTypes.shape)({
        city: _propTypes.string,
        country: _propTypes.string
      }),
      rating: (0, _propTypes.shape)({
        rating: _propTypes.number,
        count: _propTypes.number
      }),
      review: (0, _propTypes.shape)({
        message: _propTypes.string,
        rating: _propTypes.string,
        count: _propTypes.string
      })
    }),
    imageHeight: _propTypes.string,
    imageWidth: _propTypes.string,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    smallCaption: _propTypes.bool,
    className: _propTypes.string,
    captionHeight: _propTypes.string,
    onClose: _propTypes.func,
    allLabel: _propTypes.string,
    selectRoomLabel: _propTypes.string,
    onSelectRoom: _propTypes.func,
    onImageEnlarge: _propTypes.func,
    onClickArrows: _propTypes.func,
    isRoomDetail: _propTypes.bool,
    roomDetail: (0, _propTypes.shape)({
      name: _propTypes.string,
      bedGroup: _propTypes.string,
      amenities: _propTypes.node
    })
  },
  DefaultProps: {
    height: 'initial',
    width: 'initial',
    images: [],
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    smallCaption: false,
    onImageEnlarge: function onImageEnlarge() {},
    onClickArrows: function onClickArrows() {}
  }
};
exports.default = _default;